import type { CityConfig } from "../city-template/types";

export const littletonConfig: CityConfig = {
  city: "Littleton",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "littleton",
  route: "/littleton",
  title: "Emergency Passport Littleton, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Littleton, Colorado — as fast as 24 hours. Same-day courier processing for Littleton, Highlands Ranch, Centennial, Englewood, and all south metro travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Littleton, CO",
  heroSubtitle: "Last-minute wedding in Mexico and your passport is expired? Business meeting in Frankfurt next week? We help Littleton residents — from historic downtown families to Ken Caryl Ranch homeowners to Columbine Valley professionals — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Littleton%20Colorado%20historic%20downtown%20Main%20Street%20with%20charming%20brick%20buildings%20lined%20with%20trees%20and%20boutique%20storefronts%2C%20the%20South%20Platte%20River%20with%20parks%20and%20greenbelt%20trails%20winding%20through%20the%20suburban%20landscape%2C%20the%20Rocky%20Mountain%20foothills%20visible%20in%20the%20distance%20under%20bright%20afternoon%20sunlight%2C%20classic%20Colorado%20small%20town%20charm%20with%20modern%20suburban%20development%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20horizontal%20composition%20with%20rich%20golden%20hour%20light&width=1800&height=700&seq=littleton-hero-001&orientation=landscape",
  heroImageAlt: "Littleton Colorado historic downtown Main Street with Rocky Mountain foothills backdrop",
  geoPosition: "39.6133;-105.0166",
  geoPlacename: "Littleton, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 17 miles east via C-470 and I-25 — about 22 minutes",
  },
  nearbyCitiesZips: [
    { name: "Littleton", zips: "80120, 80121, 80122, 80123, 80125, 80126, 80127, 80128, 80129, 80130" },
    { name: "Highlands Ranch", zips: "80126, 80129, 80130, 80163" },
    { name: "Centennial", zips: "80111, 80112, 80121, 80122" },
    { name: "Englewood", zips: "80110, 80111, 80113" },
    { name: "Greenwood Village", zips: "80111, 80121" },
    { name: "Lone Tree", zips: "80124" },
    { name: "Castle Rock", zips: "80104, 80108, 80109" },
    { name: "Parker", zips: "80134, 80138" },
    { name: "Ken Caryl", zips: "80127, 80128" },
    { name: "Lakewood", zips: "80227, 80228, 80232" },
    { name: "Columbine Valley", zips: "80123" },
    { name: "Sheridan", zips: "80110" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Littleton international travel — business or leisure" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — no need to drive to Aurora for the Colorado Passport Agency" },
    { icon: "ri-flight-takeoff-line", title: "C-470 Corridor Access", desc: "Quick access to DEN via C-470 — same-day courier coordination for last-minute flights" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in Littleton, Highlands Ranch, or Southglenn" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/denver" },
    { name: "Emergency passport help in Highlands Ranch, CO", route: "/highlands-ranch" },
    { name: "Fast passport renewal in Centennial area", route: "/littleton" },
    { name: "Urgent passport services for Englewood", route: "/littleton" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services in south metro", route: "/littleton" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Littleton remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Littleton's location along the C-470 corridor gives us quick access to the Colorado Passport Agency — but you never need to make the drive yourself.",
  fpcOfficeAddress: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
  fpcOfficeDistance: "Serving all of Arapahoe and Jefferson County communities including Littleton, Highlands Ranch, Englewood, and Centennial",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Littleton and the south metro corridor. From historic downtown Littleton to Ken Caryl Ranch, from Bowles Crossing to Southglenn — we serve every neighborhood in Littleton and the surrounding communities.",
  nearbyCitiesIntro: "We serve Littleton and all nearby south metro communities including Highlands Ranch, Centennial, Englewood, Greenwood Village, Lone Tree, Castle Rock, and Parker. We also serve the Ken Caryl and Columbine Valley neighborhoods.",
  howItWorksIntro: "Most Littleton travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — no need to drive 17 miles east to the Colorado Passport Agency.",
  mistakesIntro: "Littleton is a family-oriented community with residents who travel internationally for vacations, destination weddings, and business. Here are the most common passport mistakes we see from Littleton-area travelers.",
  testimonialsIntro: "Littleton travelers — from historic downtown residents to Ken Caryl families to Columbine Valley professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Littleton, CO? Here are the most common ones we hear from south metro travelers.",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (CDPHE)", url: "https://cdphe.colorado.gov/vital-records", desc: "Colorado Department of Public Health & Environment for vital records statewide" },
    { label: "Marriage Licenses (Arapahoe County Clerk)", url: "https://www.arapahoeco.gov/", desc: "Arapahoe County Clerk & Recorder for Littleton area" },
    { label: "Divorce Decrees (Arapahoe County District Court)", url: "https://www.courts.state.co.us/Courts/District/Index.cfm?District_ID=18", desc: "Arapahoe County District Court for divorce decree records" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Colorado vital records online via VitalChek" },
  ],
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Aurora (22 minutes each way)", "Limited appointments — book 2 weeks ahead"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Aurora drive required — ship from Littleton", "Perfect for destination weddings and family vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Littleton travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest passport service available without the drive to Aurora.",
      bullets: ["24–48 hour turnaround available", "DEN departure support", "Destination wedding and family travel expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Littleton adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Littleton address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Littleton residents and families — including young children and new U.S. citizens.",
      bullets: ["Acceptance facility scheduling in Littleton or Highlands Ranch", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Littleton residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Littleton and south metro families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Littleton and Arapahoe County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Littleton CO", description: "Urgent passport processing for Littleton Colorado travelers with immediate departure needs from DEN." },
    { name: "Expedited Passport Renewal Littleton CO", description: "Fast passport renewal for Littleton Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Littleton CO", description: "New passport application services for Littleton Colorado residents applying for their first passport." },
    { name: "Child Passport Littleton CO", description: "Minor passport services for Littleton Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Sarah M.",
      location: "Littleton, CO — Ken Caryl Ranch",
      rating: 5,
      text: "Destination wedding in Cancun with 6 days before departure. Fast Passport Center got my renewal done in 2 days. Shipped from the UPS Store on Bowles and everything was flawless.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Michael P.",
      location: "Littleton, CO — Columbine Valley",
      rating: 5,
      text: "Family trip to Italy over summer break. Four passports total — two renewals and two first-time for our kids. All processed in 5 days. Incredible service for busy families.",
      service: "Family Passport Bundle",
    },
    {
      name: "Amanda R.",
      location: "Highlands Ranch, CO",
      rating: 5,
      text: "Business conference in Singapore next week and passport had only 3 months of validity. Fast Passport Center handled it in 3 days. The daily updates were so reassuring.",
      service: "Emergency Passport",
    },
    {
      name: "Tom H.",
      location: "Englewood, CO",
      rating: 5,
      text: "Lost my passport during a move between Littleton and Englewood. Replacement in 48 hours. Unbelievable turnaround time. Saved our anniversary trip to Paris.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "lit-1",
      name: "Littleton Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5753 S Prince St",
      city: "Littleton",
      state: "CO",
      zip: "80120",
      phone: "(303) 798-0022",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Downtown Littleton, near Main Street and Prince Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Littleton acceptance facility. Convenient downtown location. Appointments recommended — walk-ins limited. Good parking.",
      icon: "ri-mail-line",
    },
    {
      id: "lit-2",
      name: "Highlands Ranch Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "9609 S University Blvd",
      city: "Highlands Ranch",
      state: "CO",
      zip: "80126",
      phone: "(303) 471-3930",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Highlands Ranch, approximately 6 miles south of downtown Littleton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Highlands Ranch and south Littleton residents. Modern facility with good availability.",
      icon: "ri-mail-line",
    },
    {
      id: "lit-3",
      name: "Englewood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3330 S Broadway",
      city: "Englewood",
      state: "CO",
      zip: "80113",
      phone: "(303) 789-0860",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Englewood, approximately 5 miles north of downtown Littleton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for north Littleton and Englewood residents. Extended hours compared to Littleton location.",
      icon: "ri-mail-line",
    },
    {
      id: "lit-4",
      name: "Centennial Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7420 S Fraser St",
      city: "Centennial",
      state: "CO",
      zip: "80112",
      phone: "(303) 649-0332",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Centennial, approximately 8 miles east of downtown Littleton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Centennial and east Littleton residents. Good parking and shorter wait times.",
      icon: "ri-mail-line",
    },
    {
      id: "lit-5",
      name: "Arapahoe County Clerk — Littleton",
      type: "County Clerk Passport Acceptance",
      address: "5334 S Prince St",
      city: "Littleton",
      state: "CO",
      zip: "80120",
      phone: "(303) 795-4200",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Littleton, in the Arapahoe County Administration Building",
      website: "https://www.arapahoeco.gov/",
      websiteLabel: "Arapahoe County Clerk",
      notes: "County clerk passport acceptance. Extended hours compared to post office. Convenient downtown Littleton location with good parking.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 22-min drive to Aurora on C-470", fpc: "No — ship from Littleton" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Family Travel", agency: "One appointment per person", fpc: "Bundle all family members together" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Booking International Travel Before Checking Passports",
      description: "Littleton families commonly book international vacations months ahead but forget to check passport expiration dates. Routine processing takes 8–11 weeks. Check passports before booking.",
    },
    {
      icon: "ri-image-line",
      title: "Incorrect Passport Photos",
      description: "Photos from drug stores or self-service kiosks frequently get rejected for wrong size, shadows, or incorrect background. Use a professional passport photo service and verify before submission.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Waiting Too Long for Acceptance Facility Appointments",
      description: "Littleton and Highlands Ranch post offices get booked solid during summer (June–August) and holiday season. Schedule your acceptance facility appointment 2–3 weeks in advance.",
    },
    {
      icon: "ri-parent-line",
      title: "Not Bringing Both Parents for Minors",
      description: "Both parents must appear in person for a child's first passport (under 16). Many Littleton families arrive with only one parent and get turned away — a very common but costly mistake.",
    },
    {
      icon: "ri-global-line",
      title: "Ignoring 6-Month Passport Validity Rules",
      description: "Many countries require 6 months of passport validity beyond your travel dates. Littleton travelers heading to Italy, France, or Japan frequently discover this requirement days before departure.",
    },
    {
      icon: "ri-file-list-line",
      title: "Using the Wrong Renewal Form",
      description: "Not all renewals use the same form. If your passport was issued more than 15 years ago, is damaged, or you have a name change without documentation, you must use form DS-11 instead of DS-82.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Littleton or the south metro area." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Littleton, Highlands Ranch, or Englewood." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for south metro documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no C-470 or I-25 drive required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Littleton address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Littleton, CO?", a: "Fast Passport Center offers emergency passport processing in Littleton, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to make the 17-mile drive to the Colorado Passport Agency in Aurora." },
    { q: "Does Littleton have its own passport agency?", a: "No — Littleton does not have a regional passport agency. The nearest is the Colorado Passport Agency (17 miles east via C-470). Fast Passport Center's courier service means Littleton residents never need to deal with C-470 and I-25 traffic." },
    { q: "Can you help with passports for destination weddings in Mexico?", a: "Yes — destination weddings are one of our most common urgent requests for Littleton travelers. We can process passports for the wedding party, families, and guests with turnaround as fast as 24–48 hours. Bundle pricing may be available for groups." },
    { q: "What if I live in Highlands Ranch, Centennial, or Englewood?", a: "Absolutely. Fast Passport Center serves all of Arapahoe County and the south metro area including Highlands Ranch, Centennial, Englewood, Greenwood Village, Lone Tree, and Castle Rock. Our service works the same way everywhere — ship your documents and we handle the rest." },
    { q: "How much does an expedited passport cost in Littleton, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Littleton?", a: "Walgreens (8351 S Broadway and 5066 S Wadsworth Blvd) offers passport photo services. CVS at Wadsworth and Bowles also provides photos. UPS Store on Prince St and in Highlands Ranch Town Center are additional options. Photos must be 2×2 inches on a white background." },
    { q: "Can you process passports for the whole family at once?", a: "Yes. Fast Passport Center specializes in family passport bundles. We can process multiple passports — adult renewals, first-time adult, and child passports — all in one batch with a single dedicated agent managing your entire family's needs." },
    { q: "Does Fast Passport Center serve the entire C-470 corridor?", a: "Yes. Fast Passport Center serves the entire C-470 corridor from Golden to Parker, including Lakewood, Littleton, Highlands Ranch, Lone Tree, and Centennial. Our registered courier network covers the entire south metro area." },
  ],
  photoLocations: [
    { name: "Walgreens — S Broadway Littleton", address: "8351 S Broadway, Littleton, CO 80122", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Wadsworth Littleton", address: "5066 S Wadsworth Blvd, Littleton, CO 80123", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Prince St Littleton", address: "1500 W Littleton Blvd, Littleton, CO 80120", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM" },
    { name: "UPS Store — Highlands Ranch", address: "9385 S Colorado Blvd, Highlands Ranch, CO 80126", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM" },
  ],
  dmvLocations: [
    { name: "DMV — Centennial (Arapahoe County)", address: "6954 S Lima St, Centennial, CO 80112", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for Littleton and Arapahoe County residents. REAL ID and driver's license renewals. Approximately 8 miles from downtown Littleton.", featured: true },
    { name: "DMV — Lakewood (Jefferson County)", address: "2099 Wadsworth Blvd, Lakewood, CO 80214", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV for west Littleton and Jefferson County residents. REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "34 miles from Littleton via C-470 and I-70",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. About 35 minutes from Littleton.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "APA",
      name: "Centennial Airport",
      distance: "14 miles from Littleton via C-470",
      address: "7800 S Peoria St, Englewood, CO 80112",
      note: "One of the busiest general aviation airports in the U.S. Private jet and charter services available. No commercial passenger flights. Convenient for south metro business travelers.",
      flightUrl: "https://www.centennialairport.com/",
      flightLabel: "APA Airport Info",
      featured: false,
    },
    {
      code: "COS",
      name: "Colorado Springs Airport",
      distance: "65 miles from Littleton via I-25 south",
      address: "7770 Milton E Proby Pkwy, Colorado Springs, CO 80916",
      note: "Alternative regional airport with domestic connections. About 1 hour south of Littleton.",
      flightUrl: "https://www.flycos.com/",
      flightLabel: "COS Flight Info",
      featured: false,
    },
  ],
};